<div style="float:left; width: 100%; height: 380px;">
    <jqxGrid #grid [theme]="environment.tema" [width]="'98%'" [height]="'100%'" [source]="dataAdapter"
        [columnsresize]="true" [filterable]="true" [columns]="columns" [sortable]="true" [altrows]="true"
        [showrowlines]="false" [filterrowheight]="30" [rowsheight]="25" [columnsheight]="25" [showaggregates]="true"
        [showstatusbar]="true" [statusbarheight]="20" [localization]="langGrid"
        (onBindingcomplete)="onBindingComplete()">
    </jqxGrid>
</div>